export default "__VITE_ASSET__CA30PZuF__"